import { DatePicker, Space } from "antd";
import { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Request from "../commons/request";
import * as Common from "../commons/common";
import * as TypeUtils from "../commons/typeUtils";
import * as Utils from "../utils/utils";

import locale from "antd/es/date-picker/locale/ko_KR";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import moment from "moment";

function SearchDate({ startDate, endDate, onSearch }: { startDate?: string; endDate?: string; onSearch: (type: string, value: string) => void }) {
    const [holidays, setHolidays] = useState<Array<TypeUtils.Holidays>>([]);
    const [currentYear, setCurrentYear] = useState<number>(moment().year());

    useEffect(() => {
        requestGetHolidays(currentYear);
    }, []);

    const requestAxiosGetHolidays = async (year: string, month?: string) => {
        const response = await utilAxiosWithAuth().get(Request.RENT_HOLIDAYS_URL, { params: { year: year, month: month } });
        return response.data;
    };

    const {
        loading: loadingGetHolidays,
        error: errorGetHolidays,
        data: resultGetHolidays,
        execute: requestGetHolidays,
    } = useAsyncAxios(requestAxiosGetHolidays);

    useEffect(() => {
        if (resultGetHolidays === null) return;

        console.log("resultGetHolidays", resultGetHolidays);

        setHolidays(resultGetHolidays.holidays);
    }, [resultGetHolidays]);

    useEffect(() => {
        if (errorGetHolidays === null) return;

        console.log("errorGetHolidays", errorGetHolidays);
    }, [errorGetHolidays]);

    const isHoliday = (current: dayjs.Dayjs) =>
        holidays?.find((holiday) => {
            if (holiday.date === current.format(Common.FORMAT_DATE)) {
                return true;
            } else {
                return false;
            }
        });

    return (
        <Space size={8}>
            <DatePicker
                locale={locale}
                placeholder="00/00/00"
                format="YYYY-MM-DD"
                inputReadOnly={true}
                cellRender={(current) => {
                    return (
                        <div className="ant-picker-cell-inner" style={{ color: isHoliday(current) ? "var(--danger-color)" : "" }}>
                            {current.date()}
                        </div>
                    );
                }}
                value={startDate !== undefined ? dayjs(startDate.valueOf()) : undefined}
                onChange={(value) => onSearch("startDate", Utils.utcToLocalTime(String(value).valueOf(), Common.FORMAT_DATE_TIME))}
                allowClear={false}
            />
            <span>~</span>
            <DatePicker
                placeholder="00/00/00"
                format="YYYY/MM/DD"
                inputReadOnly={true}
                cellRender={(current) => {
                    return (
                        <div className="ant-picker-cell-inner" style={{ color: isHoliday(current) ? "var(--danger-color)" : "" }}>
                            {current.date()}
                        </div>
                    );
                }}
                value={endDate !== undefined ? dayjs(endDate.valueOf()) : undefined}
                onChange={(value) => onSearch("endDate", Utils.utcToLocalTime(String(value).valueOf(), Common.FORMAT_DATE_TIME))}
                allowClear={false}
                popupClassName="endDatePopup"
            />
        </Space>
    );
}

export default SearchDate;
